import { buildLocationNameClasses } from '../../utils/locationName';

export default function getLocationNameMarkup({ code, name, type, kind, className = '' }) {
  if (!name) {
    return '';
  }

  const classes = buildLocationNameClasses({ code, type, kind, className });

  return `<span class="${classes}">${name}</span>`;
}
